import { render } from "./JsonYaml.vue?vue&type=template&id=55ca35b3"
import script from "./JsonYaml.vue?vue&type=script&lang=js"
export * from "./JsonYaml.vue?vue&type=script&lang=js"

import "./JsonYaml.vue?vue&type=style&index=0&id=55ca35b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__